import React from "react";
import { AuthConsumer } from "./AuthProvider";
import { LoadingModal } from "../modals"

const Callback = () => (
    <AuthConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback();
            return <LoadingModal isBusy={true} loadingText="Loading..." />;
        }}
    </AuthConsumer>
);

export default Callback;